<template>
<v-container>
    

    <v-divider class="mt-12"></v-divider>
    <h2 class="text-center">Configuro mis Lineas</h2>
    <v-divider></v-divider>
    <v-btn 
    block
    class="mx-auto"
    color="success" 
    dark @click.stop="nombre='',uuid='',intervalo='',$store.commit('dialogoAgregaLinea')" >
    Nueva Linea</v-btn>

    <agregaLinea
        :Nombre="nombre"
      :picture="picture"
      :color="color"
      :intervalo="intervalo"
      :uuid="uuid"
    />


    <v-layout row wrap pa-2>

        <v-flex xs12 class="pa-2">
                        <v-row  no-gutters>
                    <v-col
                        v-for="cate in categoria"  v-bind:key="cate"
                        cols="6"
                        xs="6"
                        sm="4"
                        md="3">

                        <v-card
                        class="pa-3 font-italic text-center"
                        outlined
                        :color="cate.color"
                        tile
                        >{{cate.intervalo}} - {{cate.nombre}}
                                <v-img
                                class="text-left"
                                aspect-ratio="0.7"
                                :src="cate.foto">
                                
                                <p>
                                <router-link :to="/gestionfotos/+'lineas'+'/'+cate.nombre"  > 
                                <v-btn icon color="error">
                                <v-icon>fas fa-camera</v-icon>
                                </v-btn>
                                 </router-link> 
                                </p>
                                
                                <p>
                                <v-btn outline icon color="error" 
                                @click.stop="nombre=cate.nombre,
                                picture=cate.foto,
                                intervalo=cate.intervalo,
                                uuid=cate.identificador,
                                $store.commit('colorelegido',cate.color),
                                 $store.commit('dialogoAgregaLinea')">
                                <v-icon>fas fa-wrench</v-icon>
                                </v-btn>
                                </p>
                                <template v-slot:placeholder>
                                    <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                    >
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                                </v-img>

                                 <router-link :to="/gestionCategorias/+cate.nombre"  > 
                                <v-btn icon color="pink">
                                <v-icon>fas fa-plus</v-icon>
                                </v-btn>
                                 </router-link>

                        </v-card>
                    </v-col>
                    </v-row>
        </v-flex>
    </v-layout>
 
  </v-container>
</template>

<script>
// @ is an alias to /src
import agregaLinea from '@/components/agregaLinea'
import { db } from '../db'

export default {
  name: 'gestionlineasProducto',
      
    firebase: {
        categoria : db.database().ref('lineas').orderByChild("intervalo")
    },
    components: {
        agregaLinea,
    },

    data() {
        return{
    categoria:[],
    nombre:'',
    picture:'',
    intervalo:'',
    color:'',
    uuid:''
    }
    },


    
  
}
</script>
